import React from "react";
import ReturnCompleteCrateOrder from "./ReturnCompleteCrateOrder";

const ReturnCompleteOrder = ({ route }) => {
  return <ReturnCompleteCrateOrder route={route} />;
};

export default ReturnCompleteOrder;
